import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Organisation from "./pages/Organisation";
import Onboarding from "./pages/Onboarding";
import EnterpriseMap from "./pages/EnterpriseMap";
import Capabilities from "./pages/Capabilities";
import Workflows from "./pages/Workflows";
import WorkflowDetail from "./pages/WorkflowDetail";
import WorkRoles from "./pages/WorkRoles";
import Registry from "./pages/Registry";
import Diagnostics from "./pages/Diagnostics";
import TargetModel from "./pages/TargetModel";
import Roadmap from "./pages/Roadmap";
import Reports from "./pages/Reports";
import Admin from "./pages/Admin";
import Documents from "./pages/Documents";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]"><div className="font-display text-xl tracking-tight">Loading…</div></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Home />} />
              <Route path="/organisation" element={<Organisation />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/map" element={<EnterpriseMap />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/workflows" element={<Workflows />} />
              <Route path="/workflows/:id" element={<WorkflowDetail />} />
              <Route path="/work-roles" element={<WorkRoles />} />
              <Route path="/data" element={<Registry kind="data" />} />
              <Route path="/technology" element={<Registry kind="technology" />} />
              <Route path="/governance" element={<Registry kind="governance" />} />
              <Route path="/diagnostics" element={<Diagnostics />} />
              <Route path="/target-model" element={<TargetModel />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
